import type { ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

interface EnterpriseStickyActionBarProps {
    children: ReactNode;
    position?: "top" | "bottom";
    className?: string;
}

export function EnterpriseStickyActionBar({
    children,
    position = "bottom",
    className,
}: EnterpriseStickyActionBarProps) {
    return (
        <div
            className={cn(
                "z-20 -mx-6 flex flex-wrap items-center gap-2 border-border/70 bg-background/90 px-6 py-3 backdrop-blur-sm supports-[backdrop-filter]:bg-background/75",
                position === "top" ? "sticky top-0 border-b" : "sticky bottom-0 border-t",
                className,
            )}
        >
            {children}
        </div>
    );
}
